<template>
  <transition
    appear
    name="fade"
    mode="out-in"
  >
    <div class="min-h-svh w-full flex relative isolate">
      <div v-if="isAuthenticated" class="logged-in-layout">
        <div class="print:!hidden">
          <div
            v-if="isEmployee"
            class="flex justify-center items-center p-2 w-full border text-primary font-bold top-0 left-0 z-[10000] fixed bg-white"
          >
            <span class="inline-block mr-8">You are using the new UI</span>

            <BaseButton
              text="Go to old UI"
              variant="primary"
              :href="linkToOldUI"
            />
          </div>
        </div>
        <SideNavigation class="print:!hidden" />
        <main
          role="main"
          :class="[
            'flex flex-1 flex-col pb-2 lg:min-w-0 lg:pl-64 lg:pr-2 lg:pt-2 w-svw min-h-svh print:!m-0 print:!p-0',
            // 'py-10 max-w-screen-2xl mx-auto lg:pl-72',
            {
              'logged-in': isAuthenticated,
              'logged-out': !isAuthenticated
            },
            'lg:mt-[54px]'
          ]"
        >
          <div class="grow bg-white lg:p-10 lg:ring-1 lg:ring-slate-950/5 lg:rounded-lg lg:shadow-sm p-6 print:!m-0 print:!p-0">
            <div class="mx-auto max-w-screen-xl">
              <notifications class="flash-message with-sidebar flex w-full flex-col items-center space-y-4 sm:items-end" position="top right" :pause-on-hover="true" :duration="8000" />
              <Banner v-if="isAuthenticated && !isVerified" type="warning">
                <template #default>
                  Please verify your email address to access all features. Check your inbox for the verification email or 
                  <BaseButton
                    text="Send verification email"
                    variant="primary"
                    size="sm"
                    class="ml-2 mt-2"
                    @click="sendVerificationEmail"
                  />
                </template>
              </Banner>
              <router-view :key="$route.fullPath" />
            </div>
          </div>
        </main>
      </div>

      <div v-else class="logged-out-layout w-full print:!m-0 print:!p-0">
        <notifications class="flash-message flex w-full flex-col items-center space-y-4 sm:items-end" position="top right" :pause-on-hover="true" :duration="8000" />
        <router-view :key="$route.fullPath" />
      </div>
    </div>
  </transition>
</template>

<script lang="ts" setup>
import { onBeforeMount, ref, watch } from 'vue'
import SideNavigation from '@/components/TheSideNavigation.vue'
import { useHead } from '@unhead/vue'
import { useAuth } from '@/composables/useAuth'
import { onAuthStateChanged } from 'firebase/auth'
import FirebaseService from '@/services/FirebaseService'
import { useRoute } from 'vue-router'
import BaseButton from '@/components/base/BaseButton.vue'
import Banner from '@/components/base/Banner.vue'
import { AuthService } from '@/services/AuthService'
import { useNotification } from '@kyvg/vue3-notification'

useHead({
  title: 'Home',
  titleTemplate: '%s | Uttrly',
  htmlAttrs: {
    class: 'h-full bg-primary-800'
  },
  bodyAttrs: {
    class: 'h-full'
  }
})

const { isAuthenticated, isVerified, isEmployee } = useAuth()
const $route = useRoute()
const linkToOldUI = ref('http://app.uttrly.com')
const authService = new AuthService()
const { currentUser } = useAuth()
const { notify } = useNotification()

watch($route, () => {
  linkToOldUI.value = `http://app.uttrly.com${$route.fullPath}`
})

const sendVerificationEmail = async () => {
  await authService.sendVerificationEmail(currentUser.value?.email || '', window.location.href)
  notify({
    type: 'success',
    title: 'Verification email sent',
    text: 'Please check your inbox for the verification email'
  })
}

onBeforeMount(async () => {
  FirebaseService.auth().then(auth => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        await authService.syncProfile(user)
      }
    })
  })
})
</script>

<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>
